import styled from 'styled-components';

const Container = styled.label`
  span {
    white-space: nowrap;
  }
  display: block;
  position: relative;
  cursor: pointer;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '16px')};
  white-space: ${(props) => (props.whiteSpace ? props.whiteSpace : 'normal')};
  text-overflow: ${(props) =>
    props.textOverflow ? props.textOverflow : 'initial'};
  overflow: ${(props) => (props.overflow ? props.overflow : 'initial')};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: ${(props) => (props.width ? props.width : 'fit-content')};
  margin: ${(props) => (props.margin ? props.margin : '0')};
  color: ${(props) => props.theme.checkBoxBorderColor};
`;

const CheckBox = styled.input`
  position: absolute;
  padding: 24px 0 24px 0;
  opacity: 0;
  height: 0px;
  width: 0px;
  &:checked ~ .checkMark {
    background-color: ${(props) => {
      if (props.disabled) {
        return props.$indeterminate ? 'transparent' : '#da0c0c85';
      }
      return props.$indeterminate ? 'transparent' : '#da0c0c';
    }};
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    &:after {
      opacity: 1 !important;
    }
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

const CheckMark = styled.span`
  position: absolute;
  left: 0;
  height: 22px;
  width: 22px;
  border: 1px solid #ccd0e3;
  transition: background-color 0.1s ease-in-out;
  border-radius: 2px;
  &:after {
    left: 6px;
    top: 2px;
    width: 6px;
    height: 10px;
    border: ${(props) => (props.$indeterminate ? 'solid grey' : 'solid white')};
    content: '';
    opacity: ${(props) => (props.$indeterminate && !props.checked ? 1 : 0)};
    position: absolute;
    transition: opacity 0.1s ease-in-out;
    border-width: ${(props) =>
      props.$indeterminate ? '0 2px 0px 0' : '0 2px 2px 0'};
    transform: ${(props) =>
      props.$indeterminate ? 'rotate(90deg)' : 'rotate(45deg)'};
  }
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  width: fit-content;
  margin-bottom: 12px;
  color: ${(props) => props.theme.COLOR_ERROR_TEXT};
`;

const NoErrorMessage = styled.div`
  height: 18px;
  margin-bottom: 12px;
`;

const LabelSpan = styled.span`
  margin-left: 32px;
  white-space: normal !important;
  color: ${(props) => props.theme.inputHeaderColor};
`;

const CheckBoxStyle = {
  CheckMark,
  CheckboxContainer,
  Container,
  NoErrorMessage,
  LabelSpan,
  CheckBox,
  ErrorMessage,
};

export default CheckBoxStyle;
